module.exports = __webpack_public_path__ + "img/login-key.040724a7.svg";